import $ from 'jquery'

class Modal {
  constructor({ el }) {
    this.$el = $(el)
    this.$modal = $('.p-modal')
    this.$modalItems = $('.p-modal__item')
    this.$modalClose = $('.p-modal__close, .js-close')
    this.$el.on('click', () => this.show())
    this.$modal.on('click', e => this.hide(e))
    this.content = this.$el.data('modal')
    this.$modalClose.on('click', e => this.hide(e))

    this.$modalItems.each(function() {
      if ($(this).hasClass('is-current')) {
        $(this).show()
      }
    })
  }

  show() {
    const content = this.content
    this.$modal.fadeIn().addClass('is-show')
    this.$modalItems.each(function() {
      if ($(this).data('modal') === content) {
        $(this).show()
      }
    })
  }

  hide(e) {
    e.stopPropagation()
    if (
      e.target.className === 'p-modal__wrapper' ||
      e.currentTarget.className === 'p-modal__close' ||
      e.target.className === 'p-modal__content__link'
    ) {
      this.$modal.fadeOut(function() {
        $(this).removeClass('is-show').removeClass('is-current')
      })
    }
  }
}

export default Modal